import React from 'react';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import "./Footer.css"

const Footer = () => {
    const [isFixed, setIsFixed] = useState(true);

    const { t } = useTranslation();

    const handleResize = () => {
        const body = document.body;
        const windowHeight = window.innerHeight;
        const contentHeight = body.clientHeight;
        setIsFixed(contentHeight <= (windowHeight - 120));
    };

    useEffect(() => {
        handleResize();
        const resizeObserver = new ResizeObserver(() => {
            handleResize();
        });

        resizeObserver.observe(document.body);
        return () => resizeObserver.disconnect();
    }, []);

    return (
        <footer className="footer costa-footer w-100" style={{
            position: isFixed ? 'fixed' : 'static',
            bottom: isFixed ? 0 : '',
            right: 0,
            left: 0,
        }}>
            <div className="footer-container h-100">
                <div className="costa-legal-notes w-50 h-100">
                    <p>
                        © 2025 Costa Crociere S.p.A. <br /> Partita IVA IT 02545900108 <br />
                        <span>{t('all_rights_reserved')}</span>
                    </p>
                    <div>
                        <Link to={"/termsConditions"}>
                            <span>Terms&amp;Conditions</span>
                        </Link>
                        <span className="dy-separator-sections"> | </span>
                        <Link to={"/privacy"}>
                            <span> Privacy</span>
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;